let tokenClient = null;
let pendingResolve = null;
let pendingReject = null;

const TOKEN_KEY = "google_drive_token";
const EXPIRES_KEY = "google_drive_token_expires_at";
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "921508136804-mmt99lenjet2bsd4d3ue7l1u72k3kp68.apps.googleusercontent.com";
const SCOPES = "https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.profile email";

function onTokenResponse(response) {
  if (response.access_token) {
    localStorage.setItem(TOKEN_KEY, response.access_token);
    if (response.expires_in) {
      localStorage.setItem(EXPIRES_KEY, String(Date.now() + response.expires_in * 1000));
    }
    if (pendingResolve) {
      pendingResolve(response.access_token);
      pendingResolve = null;
      pendingReject = null;
    }
  } else {
    if (pendingReject) {
      pendingReject(new Error(response.error || "Failed to get Google access token"));
      pendingResolve = null;
      pendingReject = null;
    }
  }
}

export function initTokenClient() {
  if (window.google && window.google.accounts && window.google.accounts.oauth2) {
    try {
      tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: CLIENT_ID,
        scope: SCOPES,
        callback: onTokenResponse,
      });
      return true;
    } catch (e) {
      console.warn("Failed to init Google token client:", e);
      return false;
    }
  }
  return false;
}

export function requestAccessToken() {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem(TOKEN_KEY);
    const expiresAt = localStorage.getItem(EXPIRES_KEY);

    if (token && expiresAt && Date.now() < parseInt(expiresAt, 10) - 60000) {
      resolve(token);
      return;
    }

    if (!tokenClient && !initTokenClient()) {
      reject(new Error("Google OAuth not available"));
      return;
    }

    pendingResolve = resolve;
    pendingReject = reject;

    try {
      tokenClient.requestAccessToken({ prompt: "" });
    } catch (e) {
      reject(new Error("Google token unavailable. Please try refreshing the page or re-login."));
    }
  });
}

let refreshTimer = null;

export function startProactiveGoogleTokenRefresh() {
  if (refreshTimer) clearInterval(refreshTimer);
  refreshTimer = setInterval(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    const expiresAt = localStorage.getItem(EXPIRES_KEY);
    if (!token || !expiresAt) return;
    if (Date.now() >= parseInt(expiresAt, 10) - 120000) {
      try {
        await requestAccessToken();
      } catch {}
    }
  }, 40 * 60 * 1000);
}

export function stopProactiveGoogleTokenRefresh() {
  if (refreshTimer) {
    clearInterval(refreshTimer);
    refreshTimer = null;
  }
}

export function requestAccessTokenWithConsent() {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem(TOKEN_KEY);
    const expiresAt = localStorage.getItem(EXPIRES_KEY);

    if (token && expiresAt && Date.now() < parseInt(expiresAt, 10) - 60000) {
      resolve(token);
      return;
    }

    if (!tokenClient && !initTokenClient()) {
      reject(new Error("Google OAuth not available"));
      return;
    }

    pendingResolve = resolve;
    pendingReject = reject;

    try {
      tokenClient.requestAccessToken();
    } catch (e) {
      reject(new Error("Google token unavailable. Please try refreshing the page or re-login."));
    }
  });
}
